import * as React from 'react';
import { css, injectGlobal } from '@emotion/css';

export interface IFrameProps {
    src: string;
}

injectGlobal`
  .glo-bar-win-box,
  .signup-popup,
  .glo-bar-left-box,
  .Header-regionPopup,
  .ecoflow-frame-totop,
  .page-layout > .footer
  {
    display: none !important;
  }
  .allContentContainer {
    min-height: auto !important;
  }
`;

const BkwFrame: React.FC<IFrameProps> = ({ src }) => {
    const iframeRef = React.useRef<HTMLIFrameElement>(null);
    const [frameHeight, setFrameHeight] = React.useState('100%');

    const frameStyle = css`
        position: absolute;
        top: 0;
        left: 0;
        padding: 0;
        margin: 0;
        border: none;
        width: 100%;
        height: ${frameHeight};
    `;

    // postmessage to iframe
    // React.useEffect(() => {
    //     const handleMessage = (event: MessageEvent) => {
    //         if (iframeRef.current?.contentWindow === event.source) {
    //             console.log('Received message from iframe:', event.data);
    //         }
    //     };

    //     window.addEventListener('message', handleMessage);
    //     return () => window.removeEventListener('message', handleMessage);
    // }, []);

    React.useEffect(() => {
        const adjustHeight = () => {
            const header = document.querySelector('.ecoflow-frame-header');
            if (header) {
                const headerHeight = header.clientHeight;
                const windowHeight = window.innerHeight;
                const newHeight = windowHeight - headerHeight;
                setFrameHeight(`${newHeight}px`);
            }
        };
        adjustHeight();
        window.addEventListener('resize', adjustHeight);

        return () => {
            window.removeEventListener('resize', adjustHeight);
        };
    }, []);

    return (
        <iframe
            src={src}
            ref={iframeRef}
            className={frameStyle}
            sandbox="allow-popups allow-scripts allow-same-origin"
            allowFullScreen
            allow="vr xr accelerometer camera gyroscope magnetometer microphone midi encrypted-media autoplay"
            onLoad={() => {
                console.log('iframe loaded');
            }}
        ></iframe>
    );
};

export default BkwFrame;
